import { Route } from '@angular/router';
import { PAGE_TITLE_SUFFIX } from '../../../app.constants';
import { PlanSiteComponent } from './plan-site.component';

export const planSiteRoute: Route = {
    path: 'plan-site',
    component: PlanSiteComponent,
    data: {
        needAuthentication: false,
        pageTitle: `Plan du site${PAGE_TITLE_SUFFIX}`
    }
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/footer/plan-site/plan-site.route.ts